import { useLayoutEffect, useRef, type RefObject } from "react";

function countDigitsBeforeIndex(value: string, index: number): number {
  let count = 0;
  for (let i = 0; i < Math.min(index, value.length); i += 1) {
    if (/\d/.test(value[i] ?? "")) count += 1;
  }
  return count;
}

function caretIndexForDigits(value: string, digitsCount: number): number {
  if (digitsCount <= 0) return 0;
  let digitsSeen = 0;
  for (let i = 0; i < value.length; i += 1) {
    if (/\d/.test(value[i] ?? "")) digitsSeen += 1;
    if (digitsSeen >= digitsCount) return i + 1;
  }
  return value.length;
}

export function useMaskedDigitsCaret(maskedValue: string): {
  inputRef: RefObject<HTMLInputElement>;
  captureCaret: (rawValue: string, caretIndex: number | null) => void;
} {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const digitsLeftRef = useRef<number | null>(null);

  const captureCaret = (rawValue: string, caretIndex: number | null) => {
    digitsLeftRef.current = countDigitsBeforeIndex(rawValue, caretIndex ?? rawValue.length);
  };

  useLayoutEffect(() => {
    const digitsLeft = digitsLeftRef.current;
    if (digitsLeft === null) return;

    const input = inputRef.current;
    if (!input) return;

    const nextCaret = caretIndexForDigits(maskedValue, digitsLeft);
    input.setSelectionRange(nextCaret, nextCaret);
    digitsLeftRef.current = null;
  }, [maskedValue]);

  return { inputRef, captureCaret };
}
